import React, { useEffect, useState } from "react";
import media from "../../../media";
import { AllRangePicker } from "../../../components/atoms/formFields/rangePicker/allRangePicker";

import { useDispatch, useSelector } from "react-redux";
import moment from "moment";
import TableLoader from "../../../components/atoms/Loader/tableLoader";
import VendorStore from "../../../components/atoms/vendorStores";
import { dashTopSellerProductsThunk } from "../../../store/thunks/dashboardThunk";

export default function BestsellingProducts() {
  const dispatch = useDispatch();
  const { list, loading } = useSelector((state) => state?.dashTopSeller || {});
  const { storeId } = useSelector((state) => state?.storeData || {});
  const [filter, setFilter] = useState({
    fromDate: "",
    toDate: "",
  });

  useEffect(() => {
    if (storeId) {
      setFilter((prev) => ({
        ...prev,
        inventoryId: storeId,
      }));
    }
  }, [storeId]);

  useEffect(() => {
    dispatch(
      dashTopSellerProductsThunk({
        paginationFilter: { limit: 10, offset: 0, order: "DESC" },
        fromDate: filter?.fromDate,
        toDate: filter?.toDate,
        inventoryId: filter?.inventoryId,
      })
    );
  }, [dispatch, filter]);

  return (
    <>
      <div className="d-flex justify-content-between my-5">
        <VendorStore
          value={filter?.inventoryId}
          onChange={(val) => {
            if (val) {
              setFilter({
                ...filter,
                inventoryId: val.value,
              });
            } else {
              setFilter({
                ...filter,
                inventoryId: "",
              });
            }
          }}
        />
        <AllRangePicker
          disabledDate={(current) => moment().add(0, "days") <= current}
          onChange={(value) => {
            if (value) {
              setFilter({
                ...filter,
                fromDate: moment(value[0]["$d"]).format("DD/MM/YYYY"),
                toDate: moment(value[1]["$d"]).format("DD/MM/YYYY"),
              });
            } else {
              setFilter({
                ...filter,
                fromDate: null,
                toDate: null,
              });
            }
          }}
        />
      </div>

      <div className="table-responsive font-weight-bold">
        <table className="table table-bordered m-0 border radius-remove all_domain_table">
          <thead className="text-white bg-gray-700">
            <tr>
              <th className="above-column">Sr. No</th>
              <th className="above-column">Product Image</th>
              <th className="above-column">Product Name</th>
              <th className="above-column">Brand Name</th>
              {/* <th className="above-column">Sold by</th> */}
              <th className="above-column">Sale Quantity</th>
            </tr>
          </thead>

          <tbody>
            {loading ? (
              <tr>
                <td colSpan={6}>
                  <TableLoader />
                </td>
              </tr>
            ) : list?.length > 0 ? (
              list.map((list, i) => (
                <tr key={i}>
                  <td>{i + 1}</td>
                  <td>
                    <img
                      src={list?.imageUrl || media.Default}
                      className="max-w-70px"
                      alt="Product"
                    />
                  </td>
                  <td className="font-weight-bolder text-left">
                    {list?.productName?.en} - {list?.variant}
                  </td>
                  <td className="font-weight-bolder text-left">
                    {list?.brandName?.en}
                  </td>
                  {/* <td nowrap="nowrap">
                    <span>{list?.vendor}</span>
                    <span className="mt-2 d-block">{list?.store}</span>
                  </td> */}
                  <td>{list?.totalSale}</td>
                </tr>
              ))
            ) : (
              <tr>
                <td colSpan={6}>No Data Found</td>
              </tr>
            )}
          </tbody>
        </table>
      </div>
    </>
  );
}
